export default __webpack_public_path__ + "static/media/declined_islamic.05459c64.gif";